import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { IExtractedProFormaSummary } from 'types/db/ExtractedProForma';

interface IExtractedProFormasQueryParams {
    organizationId: string;
    dealId: number;
}

const getExtractedProFormas = async ({ organizationId, dealId }: IExtractedProFormasQueryParams): Promise<IExtractedProFormaSummary[]> => {
    const response = await axiosInstance.get(`${API_ENDPOINTS.EXTRACTED_PRO_FORMAS(organizationId, dealId)}`);
    return response.data;
};

export const useGetExtractedProFormasByDeal = ({ organizationId, dealId }: IExtractedProFormasQueryParams) => useQuery({
    queryKey: ['extractedProFormas', dealId],
    queryFn: () => getExtractedProFormas({ organizationId, dealId }),
    enabled: !!organizationId,
    staleTime: 5000,
    refetchOnMount: true,
});

export default useGetExtractedProFormasByDeal;
